import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import ControlledInput from '../../components/ControlledInput';
import { COMMON_FORM_ERRORS } from '../../constants';
import { ControlledCheckbox } from '../../components/Checkbox';
import BtnFilled from '../../components/BtnFilled';
import Modal from '../../components/Modal';
import PersonalData from '../../components/PersonalData';
import TermsOfUse from '../../components/TermsOfUse';
import ControlledInputPassword from '../../components/ControlledInputPassword';
import { useState } from 'react';

const RegistrationForm = ({ handleSubmit, fields, error, containerClass = '', children }) => {
  const methods = useForm({ mode: 'onTouched' });

  /** for checkboxes with agreement: **/
  const [showModalPersonalData, setShowModalPersonalData] = React.useState(false);
  const [showModalTermsOfUse, setShowModalTermsOfUse] = React.useState(false);

  const personalData = methods.watch('personalData');
  const termsOfUse = methods.watch('termsOfUse');

  const renderAgreementLabel = (text, highlightLink, onClick) => (
    <>
      {text}{' '}
      <button onClick={onClick} className="inline text-orange-500 underline cursor-pointer text-start">
        {highlightLink}
      </button>
    </>
  );

  const [isPasswordValid, setIsPasswordValid] = useState(false);

  return (
    <div className="w-full max-w-lg">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)} className={`bg-white rounded-b-3xl ${containerClass} px-4 sm:px-8 pt-6 pb-8`}>
          {fields.map((input) => {
            if (input.type === 'password') {
              return (
                <ControlledInputPassword
                  classContainer={'mb-4'}
                  showTips={true}
                  handleTipsPassword={setIsPasswordValid}
                  key={input.name}
                  rules={{
                    required: {
                      value: true,
                      message: COMMON_FORM_ERRORS.REQUIRED,
                    },
                  }}
                  {...input}
                />
              );
            }
            return (
              <ControlledInput
                key={input.name}
                classContainer={'mb-4'}
                rules={{
                  required: {
                    value: true,
                    message: COMMON_FORM_ERRORS.REQUIRED,
                  },
                }}
                {...input}
              />
            );
          })}
          {error && <p className="mb-4 text-red-500 p-0 font-bold text-xs italic">{error}</p>}
          <ControlledCheckbox
            control={methods.control}
            name={'personalData'}
            label={renderAgreementLabel('Я соглашаюсь на обработку', 'Персональных данных', () => setShowModalPersonalData(true))}
          />

          <ControlledCheckbox
            control={methods.control}
            name={'termsOfUse'}
            label={renderAgreementLabel('Я принимаю условия', 'Пользовательского соглашения', () => setShowModalTermsOfUse(true))}
          />

          <BtnFilled disabled={!personalData || !termsOfUse || !isPasswordValid} className={'my-4'} type={'submit'} title="Зарегистрироваться" />
          {children && children}
        </form>
      </FormProvider>

      <Modal
        showModal={showModalPersonalData}
        setShowModal={setShowModalPersonalData}
        title="Политика в отношении обработки персональных данных"
        showSave={false}
        error={null}
        classWidth="relative w-11/12 lg:w-1/2 my-6 mx-2">
        <PersonalData />
      </Modal>

      <Modal
        showModal={showModalTermsOfUse}
        setShowModal={setShowModalTermsOfUse}
        title="Пользовательское соглашение"
        showSave={false}
        error={null}
        classWidth="relative w-11/12 lg:w-1/2 my-6 mx-2">
        <TermsOfUse />
      </Modal>
    </div>
  );
};

export default RegistrationForm;
